import { busEvent } from '../main';

export default async function handlerError(err) {

  // check blob response type and convert to json
  if (
    err.request.responseType === 'blob' &&
    err.response.data instanceof Blob &&
    err.response.data.type &&
    err.response.data.type.toLowerCase().indexOf('json') != -1
  ) {
    err.response.data = JSON.parse(await err.response.data.text());
  }

  if (err.response && err.response.data && err.response.data.error) {

    // this error will be catch by axious response interceptor and it
    // will try to renew the token
    if (err.response.data.error.code !== 5) {
      busEvent.$emit('errorPopupCreated', err.response.data.error.message);
    }
  } else {
    busEvent.$emit('errorPopupCreated', err.message);
  }
}
